import { Button } from '@design-system/button';
import { FluidGrid } from '@design-system/fluid-grid';
import React, { FC, useMemo } from 'react';

import { PageCard } from '~/components/page-card';
import TMPLinkWrap from '~/components/TMPLinkWrap';
import { mapToCardMeta } from '~/mappers/card/mapToCardMeta';
import { gatsbyImageMapper } from '~/mappers/image';

import { EventListingProps } from '../models';

export const EventListing: FC<EventListingProps> = ({
  items = [],
  maxVisibleItems,
  setTabValue,
  tabNumber,
  moreButtonText,
  imageSettings,
  fluidGrid,
  tabItemsTitle,
}) => {
  const visibleItems = useMemo(() => {
    if (maxVisibleItems) {
      return items.slice(0, maxVisibleItems);
    }

    return items;
  }, [maxVisibleItems, items]);

  if (!items.length) {
    return null;
  }

  return (
    <>
      {tabItemsTitle}
      <FluidGrid {...fluidGrid}>
        {visibleItems.map((item) => {
          const cardMeta = mapToCardMeta(item);

          return (
            <div className="search-result__event-listing" key={item.url}>
              <PageCard
                cardContent={{
                  headingBlock: {
                    headline: item.title,
                    description: item.description,
                    headlineVariant: 'headline',
                    headlineSize: 'm',
                  },
                }}
                {...(item.image?.data && {
                  cardMedia: {
                    image: {
                      element:
                        gatsbyImageMapper({
                          alt: item.title,
                          image: item.image.data,
                          ...imageSettings,
                        }) || undefined,
                    },
                  },
                })}
                {...(item.label?.[0]?.content && {
                  cardLabel: {
                    labelContent: item.label[0].content,
                    srOnlyLabelPrefix: item.label[0].sr_prefix,
                    labelVariant: item.label[0].variant as
                      | 'primary'
                      | 'secondary',
                    labelSize: item.label[0].size as
                      | 'small'
                      | 'large'
                      | undefined,
                  },
                })}
                link={{
                  component: TMPLinkWrap,
                  props: {
                    href: item.url,
                  },
                }}
                categories={
                  Array.isArray(item.categories)
                    ? item.categories.map(({ title }) => title)
                    : []
                }
                fullCategories={
                  Array.isArray(item.categories) ? item.categories : []
                }
                meta={cardMeta}
              />
            </div>
          );
        })}
      </FluidGrid>
      <div className="search-result__button-wrapper">
        <Button variant="secondary" onClick={() => setTabValue(tabNumber)}>
          {moreButtonText}
        </Button>
      </div>
    </>
  );
};

export default EventListing;
